import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography,Divider} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import TemplateInfo from '../TemplateInfo';
import IconEnabled from 'core/components/layout/IconEnabled';


export default function TemplateListTableRow({obj, getActionComponent,actionList,handleRowClick}){
  const {mobileView} = useSelector((state)=>state.menu);
  useEffect(()=>{
  },[])
  const getHoverColor = () =>{
    if (mobileView) return ''
    return 'primary.main';
  }
  const getHoverBackgroundColor = () =>{
    if (mobileView) return ''
    return 'secondary.200';
  }
  const getBackgroundColor = (obj) =>{
    if (mobileView) {
      if (obj.expand) return 'secondary.500'
      return 'white'
    }
    return 'white'
  }
    return (
      
      <>
        <Grid item lg={12} sx={{ width: '100%'}}>
          {/* <ROW1 - CONTAINER/> */}
          <Grid container direction="row" onClick={() => handleRowClick(obj.id)}
            sx={{cursor: 'pointer',
              justifyContent: "flex-start", alignItems: "top",  padding:1,  
              backgroundColor: getBackgroundColor(obj),
              color: mobileView && obj.expand?'primary.main':'primary.darker',
              '&:hover': {
                backgroundColor: getHoverBackgroundColor, 
                color: getHoverColor()
              },
            }}>
            {/* <ROW1 - CELLS/> */}
            
              <Grid item lg={2} xs={4}>
                <Box sx={{ width: 100, height: 100, borderRadius: 1, overflow: 'hidden', mr: 1, bgcolor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {obj.assetpath ? (
                    <img
                      src={obj.assetpath}
                      alt={obj.title}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    <svg width="100%" height="100%" viewBox="0 0 40 40">
                      <rect width="40" height="40" fill="#e0e0e0" />
                      <text x="50%" y="50%" textAnchor="middle" dy=".3em" fill="#aaa" fontSize="10">No Image</text>
                    </svg>
                  )}
                </Box>
                
              </Grid>
              <Grid item lg={2} xs={2}>
                  <Typography color="" sx={{ fontWeight: 'light', fontSize: 15, }}>{obj.title}</Typography>
              </Grid>
              <Grid item lg={6} xs={4} sx={{pl:2}}>
                <Typography
                  color=""
                  sx={{ fontWeight: 'light', fontSize: 15 }}
                  dangerouslySetInnerHTML={{
                    __html: obj.campaigntext
                      ? String(obj.campaigntext).replace(/(\r\n|\r|\n)/g, '<br/>')
                      : ''
                  }}
                />
              </Grid>

              <Grid item lg={2} xs={2} >
                <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
                  {/* {getActionComponent(obj)} */}
                  <IconEnabled key={`${obj.id}-${actionList[0].title}`} actionObj={actionList[0]} id={obj.id} />
                  <IconEnabled key={`${obj.id}-${actionList[1].title}`} actionObj={actionList[1]} id={obj.id} />
                  <IconEnabled key={`${obj.id}-${actionList[2].title}`} actionObj={actionList[2]} id={obj.id} />
                  <IconEnabled key={`${obj.id}-${actionList[3].title}`} actionObj={actionList[3]} id={obj.id} />
                </Grid>
              </Grid>
            
          </Grid>
        </Grid>
        <Grid item lg={12} sx={{ width: '100%' }}></Grid>
        {/* {obj.expand ?
        <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            < TemplateInfo  templateObj={obj} />
          </Grid>
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>
        : <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>} */}
      </>
      
    )
}